import React, { useEffect, useRef, useState } from "react";
import "./ProductList.scss";
import Buttons from "../../../components/ui/button/Buttons";
import { useAddBrandModelByProductInformationIdMutation, useDeleteSGBPProductDetailsByIdMutation, useEditSGBPProductsDetailsByIdMutation, useLazyGetProductsListByProductInformationIdQuery } from "../../../app/services/productAndService/productAndServiceApi";
import { useParams } from "react-router-dom";
import { decryptAESID } from "../../../utils/Encryption";
import NoRecordFound from "../../../components/ui/noRecordFound/NoRecordFound";
import CenterModel from "../../../components/ui/centerModel/CenterModel";
import FormCreator from "../../../components/Forms/FormCreator";
import { ProductFormData } from "./data/ProductForm.data";
import ToastService from "../../../services/toastService/ToastService";

export default function ProductList() {
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const formRef = useRef();
  const [rows, setRows] = useState([]);
  const [formData, setFormData] = useState(ProductFormData);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [corporateMemberId, setCorporateMemberId] = useState(null);
  const [getProductsListByProductInformationId, { data: getProductsListByProductInformationIdData, isLoading: getProductsListByProductInformationIdLoading, isFetching: getProductsListByProductInformationIdFerching, }] = useLazyGetProductsListByProductInformationIdQuery();
  const [addBrandModelByProductInformationId, { isSuccess: addProductIsSuccess, isLoading: addProductIsLoading, data: addProductData, },] = useAddBrandModelByProductInformationIdMutation();
  const [editProductsDetailsById, { isSuccess: editProductIsSuccess, isLoading: editProductIsLoading, data: editProductData, },] = useEditSGBPProductsDetailsByIdMutation();
  const [deleteSGBPProductDetailsById, { isSuccess: deleteSGBPProductSuccess, isLoading: deleteSGBPProductIsLoading },] = useDeleteSGBPProductDetailsByIdMutation();

  useEffect(() => {
    if (editID > 0) {
      getProductsListByProductInformationId(editID)
    }
  }, [editID])

  useEffect(() => {
    if (!getProductsListByProductInformationIdLoading && getProductsListByProductInformationIdData) {
      setCorporateMemberId(getProductsListByProductInformationIdData[0]?.sgbcCorporateMemberId);
      setRows(getProductsListByProductInformationIdData)
    }
  }, [getProductsListByProductInformationIdLoading, getProductsListByProductInformationIdData])

  // useEffect(() => {
  //   if (!addProductIsLoading && addProductData) {
  //     getProductsListByProductInformationId(editID)
  //     handleCloseModal();
  //     ToastService.success("Product added successfully.")
  //   }
  // }, [addProductIsLoading, addProductIsSuccess, addProductData]);

  useEffect(() => {
    if (!editProductIsLoading && editProductData) {
      getProductsListByProductInformationId(editID)
      setEditId(null);
      ToastService.success("Product update successfully.")
    }
  }, [editProductIsLoading, editProductIsSuccess, editProductData]);

  useEffect(() => {
    if (!deleteSGBPProductIsLoading && deleteSGBPProductSuccess) {
      ToastService.success("Product deleted successfully.")
      getProductsListByProductInformationId(editID)
    }
  }, [deleteSGBPProductIsLoading, deleteSGBPProductSuccess])

  const handleSubmit = () => {
    let form = formRef.current.getFormData();
    let req = {
      sGBCProductInformationId: editID,
      brandName: form?.brandName,
      modelName: form?.modalName,
      SGBCCorporateMemberId: corporateMemberId

    }
    if (req.sGBCProductInformationId > 0) {
      addBrandModelByProductInformationId(req);
    }
  }

  const handleEdit = (id1) => {
    setEditId(id1);
  };

  const handleChange = (id1, field, value) => {
    setRows(rows.map((r) => (r.sgbpProductDetailsId === id1 ? { ...r, [field]: value } : r)));
  };

  const handleSave = (id1) => {
    const selectedRow = rows.find((r) => r.sgbpProductDetailsId === id1);
    if (!selectedRow) return;

    const req = {
      sGBPProductId: id1,
      brandName: selectedRow.brandName,
      modelName: selectedRow?.modelName
    };
    editProductsDetailsById(req)
  };

  const handleDelete = (id) => {
    deleteSGBPProductDetailsById(id)
  };

  // const handleOpenModal = () => {
  //   setIsOpenModal(true);
  // }
  // const handleCloseModal = () => {
  //   const form = { ...ProductFormData }
  //   setIsOpenModal(false);
  //   setFormData(form);
  // }

  return (
    <div className="table-wrapper">
      <Buttons
        buttonText="+ Add Model"
        buttonTypeClassName="success-btn d-block mt-4 add-btn"
      // onClick={handleOpenModal}
      />
      <div className="brand-table">
        <table className="model-table">
          <thead>
            <tr>
              <th>Brand Name</th>
              <th>Model Name</th>
              <th>Action</th>
            </tr>
          </thead>
          {rows.length > 0 ? (
            <tbody>
              {rows.map((row) => (
                <tr key={row.sGBPProductDetailsId}>
                  <td>
                    {editId === row.sgbpProductDetailsId ? (
                      <input
                        value={row.brandName}
                        onChange={(e) =>
                          handleChange(row.sgbpProductDetailsId, "brandName", e.target.value)
                        }
                      />
                    ) : (
                      row.brandName
                    )}
                  </td>
                  <td>
                    {editId === row.sgbpProductDetailsId ? (
                      <input
                        value={row.modelName}
                        onChange={(e) =>
                          handleChange(row.sgbpProductDetailsId, "modelName", e.target.value)
                        }
                      />
                    ) : (
                      row.modelName
                    )}
                  </td>

                  <td className="action-col">
                    {editId === row.sgbpProductDetailsId ? (
                      <span className="link" onClick={() => handleSave(row.sgbpProductDetailsId)}>
                        Save
                      </span>
                    ) : (
                      <>
                        <span className="link" onClick={() => handleEdit(row.sgbpProductDetailsId)}>
                          Edit
                        </span>
                        <span
                          className="link"
                          onClick={() => handleDelete(row.sgbpProductDetailsId)}
                        >
                          Delete
                        </span>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>

          ) : (<tr>
            <td colSpan={100}>
              <NoRecordFound />
            </td>
          </tr>)}
        </table>
      </div>
      {/* <CenterModel
        show={isOpenModal}
        modelTitle="Product Form"
        handleClose={handleCloseModal}
        className="Product-modal"
      >
        <div className="applicant-role-model-content">
          <FormCreator
            ref={formRef}
            {...formData}
          />
          <Buttons
            buttonText="Submit"
            buttonTypeClassName="success-btn d-block mt-4 add-btn cursor-pointer"
            onClick={handleSubmit}
            isLoading={addProductIsLoading}
          />
        </div>
      </CenterModel> */}
    </div>
  );
}
